import { IconProps } from "@/data/types"

export default function BalconyIcon({
  width = 32,
  height = 32,
  color = "#000000",
  className,
}: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" >
        <g strokeWidth="0"></g>
        <g strokeLinecap="round" strokeLinejoin="round"></g>
        <g>
          <line x1="23.45" y1="22.5" x2="0.55" y2="22.5" stroke={color} strokeWidth="0.72" strokeMiterlimit="10" />
          <line x1="12" y1="14.86" x2="12" y2="22.5" stroke={color} strokeWidth="0.72" strokeMiterlimit="10" />
          <line x1="16.77" y1="14.86" x2="16.77" y2="22.5" stroke={color} strokeWidth="0.72" strokeMiterlimit="10" />
          <line x1="2.45" y1="12.95" x2="2.45" y2="22.5" stroke={color} strokeWidth="0.72" strokeMiterlimit="10" />
          <line x1="7.23" y1="14.86" x2="7.23" y2="22.5" stroke={color} strokeWidth="0.72" strokeMiterlimit="10" />
          <line x1="21.55" y1="12.95" x2="21.55" y2="22.5" stroke={color} strokeWidth="0.72" strokeMiterlimit="10" />
          <line x1="0.55" y1="14.86" x2="23.45" y2="14.86" stroke={color} strokeWidth="0.72" strokeMiterlimit="10" />
          <circle cx="2.45" cy="12" r="0.95" stroke={color} strokeWidth="0.72" strokeMiterlimit="10" />
          <circle cx="21.55" cy="12" r="0.95" stroke={color} strokeWidth="0.72" strokeMiterlimit="10" />
          <path
            d="M12,1.5h0a5.73,5.73,0,0,1,5.73,5.73v7.64H6.27V7.23A5.73,5.73,0,0,1,12,1.5Z"
            stroke={color}
            strokeWidth="0.72"
            strokeMiterlimit="10"
          />
          <line x1="12" y1="1.5" x2="12" y2="14.86" stroke={color} strokeWidth="0.72" strokeMiterlimit="10" />
          <line x1="6.27" y1="9.14" x2="17.73" y2="9.14" stroke={color} strokeWidth="0.72" strokeMiterlimit="10" />
        </g>
      </svg>
    </div>
  )
}
